export const CTA_TYPE = {
  UNJOINED: "unjoined",
  JOINED: "joined",
  JOINED_CLOSED: "joined_closed",
  CLOSED: "closed",
  FULL: "full",
  HOST: "host",
  HOST_CLOSED: "host_closed",
  PROJECT_UNJOINED_EVENT_UNJOINED: "project_unjoined_event_unjoined",
  PROJECT_JOINED_EVENT_UNJOINED: "project_joined_event_unjoined",
  PROJECT_JOINED_EVENT_JOINED: "project_joined_event_joined",
  DEFAULT: "default",
} as const;
